import React from 'react'
import ReactDOM from 'react-dom'
import NewCommissionCalculator from './containers/NewCommissionCalculator'

ReactDOM.render(
  <NewCommissionCalculator isNewPartner={true} />,
  document.getElementById('commission-calculator-new-partner')
)
